import { render, staticRenderFns } from "./PowerApp.vue?vue&type=template&id=47312941"
import script from "./PowerApp.vue?vue&type=script&lang=js"
export * from "./PowerApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports